import { SWFParser, PromiseWrapper } from '@awayfl/swf-loader';
import { AVM1Globals } from './AVM1Globals';
import { Loader, URLLoaderEvent, LoaderEvent, AssetEvent, AssetLibrary, URLRequest } from '@awayjs/core';
import { MovieClip } from '@awayjs/scene';
var AVM1LoaderHelper = /** @class */ (function () {
    function AVM1LoaderHelper(context) {
        var _this = this;
        this.result = new PromiseWrapper();
        this._context = context;
        this._onAssetCompleteDelegate = function (event) { return _this.onAssetComplete(event); };
        this._onLoaderCompleteDelegate = function (event) { return _this.onLoaderComplete(event); };
        this._onLoadErrorDelegate = function (event) { return _this.onLoadError(event); };
        this._loader = new Loader();
    }
    Object.defineProperty(AVM1LoaderHelper.prototype, "loader", {
        get: function () {
            return this._loader;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AVM1LoaderHelper.prototype, "content", {
        get: function () {
            return this._content;
        },
        enumerable: true,
        configurable: true
    });
    AVM1LoaderHelper.prototype.onAssetComplete = function (event) {
        var asset = event.asset;
        if (asset.isAsset(MovieClip)) {
            if (asset.assetNamespace != this._url) {
                return;
            }
            if (asset.isAVMScene) {
                this._content = asset;
                this.result.resolve(asset);
                asset.adapter.initAdapter();
            }
        }
    };
    AVM1LoaderHelper.prototype.onLoaderComplete = function (event) {
        if (event.url != this._url) {
            return;
        }
        AssetLibrary.removeEventListener(AssetEvent.ASSET_COMPLETE, this._onAssetCompleteDelegate);
        AssetLibrary.removeEventListener(LoaderEvent.LOADER_COMPLETE, this._onLoaderCompleteDelegate);
        AssetLibrary.removeEventListener(URLLoaderEvent.LOAD_ERROR, this._onLoadErrorDelegate);
    };
    AVM1LoaderHelper.prototype.onLoadError = function (event) {
        AssetLibrary.removeEventListener(AssetEvent.ASSET_COMPLETE, this._onAssetCompleteDelegate);
        AssetLibrary.removeEventListener(LoaderEvent.LOADER_COMPLETE, this._onLoaderCompleteDelegate);
        AssetLibrary.removeEventListener(URLLoaderEvent.LOAD_ERROR, this._onLoadErrorDelegate);
        console.log('load error in loadMovie', event);
    };
    AVM1LoaderHelper.prototype._loadingCallback = function (source, target) {
        var t = target.adaptee;
        var c = source;
        t.isAVMScene = c.isAVMScene;
        t.timeline = c.timeline;
        t.assetNamespace = c.assetNamespace;
        t.reset(true, false);
    };
    AVM1LoaderHelper.prototype.loadMovieAt = function (url, method, target) {
        var _this = this;
        if (!target) {
            throw new Error('Target can\'t be null');
        }
        var source = AVM1LoaderHelper._loaderCache[url];
        if (source) {
            this._loadingCallback(source, target);
            return Promise.resolve(target);
        }
        return this.load(url, method).then(function () {
            source = _this.content;
            if (!source) {
                return null;
            }
            AVM1LoaderHelper._loaderCache[url] = source;
            _this._loadingCallback(source, target);
            return target;
        });
    };
    AVM1LoaderHelper.prototype.load = function (url, method) {
        /*
        const rule = matchRedirect(url);
        if(rule) {
            url = rule.url;
        }*/
        this._url = url;
        this.result = new PromiseWrapper();
        AssetLibrary.addEventListener(AssetEvent.ASSET_COMPLETE, this._onAssetCompleteDelegate);
        AssetLibrary.addEventListener(LoaderEvent.LOADER_COMPLETE, this._onLoaderCompleteDelegate);
        AssetLibrary.addEventListener(URLLoaderEvent.LOAD_ERROR, this._onLoadErrorDelegate);
        AssetLibrary.load(new URLRequest(url), null, url, new SWFParser(AVM1Globals._scenegraphFactory));
        return this.result.promise;
        /*
        todo:

        var context = this._context;
        var loader = this._loader;
        var loaderContext: LoaderContext = new context.sec.flash.system.LoaderContext();
        loaderContext._avm1Context = context;
        var request = new context.sec.flash.net.URLRequest(url);
        if (method) {
            request.method = method;
        }

        var loaderInfo = loader.contentLoaderInfo;
        // Waiting for content in the progress event -- the result promise will be resolved
        // as soon as loader's content will be set to non-empty value.
        var progressEventHandler = function (e: ProgressEvent): void {
            if (!loader._content) {
                return;
            }
            loaderInfo.removeEventListener(ProgressEvent.PROGRESS, progressEventHandler);
            result.resolve(loader._content);

        };
        loaderInfo.addEventListener(ProgressEvent.PROGRESS, progressEventHandler);
        loader.load(request, loaderContext);
        */
        //return null;
    };
    AVM1LoaderHelper._loaderCache = {};
    return AVM1LoaderHelper;
}());
export { AVM1LoaderHelper };
